import React from "react"

import { Container } from "./styles"

const SuccessIcon = () => {
	return (
		<Container>
			<div class="success">
				<div class="success-tip" />
				<div class="success-long" />
				<div class="success-placeholder" />
				<div class="success-fix" />
			</div>
		</Container>
	)
}

export default SuccessIcon